import { render, staticRenderFns } from "./DeliveryDate.vue?vue&type=template&id=6b05b63b&"
import script from "./DeliveryDate.vue?vue&type=script&lang=js&"
export * from "./DeliveryDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports